export const NoMembersStyles = {
  container: {
    marginTop: 20,
    marginX: 'auto',
    textAlign: 'center',
    transform: 'translateY(50%)',
  },
  title: {
    fontWeight: 500,
    paddingTop: 8,
    fontSize: 'xl',
    color: 'textBase',
    textAlign: 'center',
    lineHeight: 'small',
    wordBreak: 'break-word',
  },
  text: {
    maxWidth: '536px',
    textAlign: 'center',
    paddingTop: 1,
    color: 'textSubdued',
    fontSize: 'md',
    lineHeight: 'normal',
    wordBreak: 'break-word',
  },
};
